import { useBusinessModalContext as s } from "../../../BusinessModalContext.js";
const i = "org_id", c = () => {
  const {
    filters: t,
    preFilters: e
  } = s(), o = t?.org_id, r = e?.searchOrg;
  return {
    [i]: o ?? (r ? Number.parseInt(r) : void 0)
  };
};
export {
  c as useGetOrganization
};
